import {
  allProjectsQuery,
  shareAccessMutation,
  generateSnapshotMutation,
  revokeAccessMutation,
} from "@/graphql/query";
import { client } from "@/main";
import { format } from "date-fns";
import { eventBus } from "@/components/EventBus";

export default {
  async getAllProjects({ commit }) {
    try {
      const { data } = await client.query({
        query: allProjectsQuery,
        fetchPolicy: "network-only",
      });
      commit("setAllProjects", data.projects);
    } catch (error) {
      console.error(`Error getting projects: ${error}`);
    }
  },
  async shareFullAccess({ commit, rootState }, emails) {
    const { selectedProjectId: project_id, selectedProjectEmails } =
      rootState.projectsStore;
    try {
      await client.mutate({
        mutation: shareAccessMutation,
        variables: {
          project_id,
          emails,
        },
        optimisticResponse: () => ({
          shareAccess: [...selectedProjectEmails, ...emails]
            .sort()
            .map((email) => ({
              email: email,
              __typename: "User",
            })),
        }),
        update: (cache, { data: { shareAccess } }) => {
          commit(
            "setSelectedProjectEmails",
            shareAccess.map((user) => user.email)
          );
          commit("setProjectUsers", { project_id, shareAccess });
        },
      });
    } catch (error) {
      console.error(`Error sharing full access: ${error}`);
    }
  },
  async generateSnapshot({ commit, rootState }) {
    const { selectedProjectId: project_id } = rootState.projectsStore;
    const version_time = format(new Date(Date.now()), "yyyy-MM-dd HH:mm");
    commit("loaderStore/setIsLoading", true, { root: true });
    try {
      const {
        data: { generateSnapshot },
      } = await client.mutate({
        mutation: generateSnapshotMutation,
        variables: {
          project_id,
          version_time,
        },
      });
      const url = `${window.location.href}project/${generateSnapshot.project_id}/copy`;
      navigator.clipboard.writeText(url);
      eventBus.$emit("duplicateLinkCopied");
    } catch (error) {
      console.error(`Error generating a snapshot: ${error}`);
    }
    commit("loaderStore/setIsLoading", false, { root: true });
  },
  async revokeAccess({ commit, rootState }, email) {
    const { selectedProjectId: project_id, selectedProjectEmails } =
      rootState.projectsStore;
    try {
      await client.mutate({
        mutation: revokeAccessMutation,
        variables: {
          project_id,
          email,
        },
        optimisticResponse: () => ({
          revokeAccess: {
            email,
            project_id,
            __typename: "UserProject",
          },
        }),
        update: (
          cache,
          {
            data: {
              revokeAccess: { email: revokedEmail },
            },
          }
        ) => {
          commit(
            "setSelectedProjectEmails",
            selectedProjectEmails.filter(
              (sharedEmail) => sharedEmail !== revokedEmail
            )
          );
          commit("removeProjectUser", { project_id, revokedEmail });
        },
      });
    } catch (error) {
      `Error revoking full access: ${error}`;
    }
  },
  async revokeOwnAccess({ dispatch, commit }, { email, project_id }) {
    try {
      commit("deleteProject", project_id);
      await client.mutate({
        mutation: revokeAccessMutation,
        variables: {
          email,
          project_id,
        },
      });
      dispatch("getAllProjects");
    } catch (error) {
      console.error(`Error revoking own access ${error}`);
    }
  },
};
